/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-04-01 16:27:02
 * @LastEditors: Mayer
 * @LastEditTime: 2024-10-08 16:42:03
 */
export default {
  lang: "英语",
  landing: {
    name1: "Carlcare بکەوە",
    name2: "ڕێزێرڤێک ئەنجام بدە",
    name3: "لەڕێگەی Carlcare، دەتوانی هەموو کاتێک داواکارییەکەت بپشکنی.",
    name4: "",
    name5: "بیخزێنە بۆلای ڕاست",
    name6: "پشتڕاستکردنەوە کۆتایی پێهات",
  },
  order: {
    name1: "مۆدێلی ئامێر هەڵبژێرە",
    name2: "شی کردنەوەی کێشە:",
    name3: "بۆ هەڵبژاردنی فرۆشگای خزمەتگوزاری کرتە بکە",
    name4: "فرۆشگای خزمەتگوزاری:",
    name5: "کاتی ڕێزێرف کردن:",
    name6: "تکایە بە وردەکارییەوە باسی گرفتی ئامێرەکەت بکە!",
    name7: "بۆ هەڵبژاردنی کاتی گەیشتن کرتە بکە",
    name8: "تکایە زانیاریی پەیوەندیییەکەت دروست بنووسە بۆ ئەوەی بتوانین پەیوەندیت پێوە بکەین",
    name9: "کاتی ڕێزێرف کردنی بەردەست بەم سێوەیەی خوارەوەیە",
    name10: "تکایە ژمارە مۆبایلەکەت بنووسە",
    name11: "نرخ",
    name12: "زانیارییە تاکەکەسییەکان:",
    name13: "تکایە ناوت بنووسە",
    name14: "ناردن",
    name15: "هەڵوەشاندنەوە",
    name16: "باشە",
  },
  shops: {
    name1: "لە سەر بنەمای ئەو بڕەندەی هەڵیدەبژێری، ئەم گرۆشگایانەی خوارەوە دەتوانن خزمەتت بکەن!",
    name2: "بەم زوویانە دووکانی فرۆشتنی زیاتر دێن! لە گەڵمان بمێنەوە!",
  },
  price: {
    name1: "بڕەند",
    name2: "مۆدێل",
    name3: "بڕگە",
    name4: "نرخ",
    name5: "وەبیرهێنەرەوەی هاوڕێیانە:",
    name6: "ئەم نرخانە تەنیا بۆ ژێدەرن، و نرخی ڕاستەقینەکە پەیوەندیی بە بارودۆخی ئامێرەکەت هەیە.",
    name7: "ئەگەر هیچ هێمایەکی تایبەتی نەبێت، یەکەی نرخەکە یەکەی دراوی خۆجێیە.",
    name8: "بەداخەوەین! لەم هەرێمەی ئێستاد هیچ زانیارییەکی نرخ لەبەردەستدا نییە.",
    name11:"تێچووی کرێکاران",
    name12:"نرخی گشتی",
    name13: "٥. ئەگەر تێچووی کار \"/\" بێت، بەواتای ئەمەیە کە تێچووی کار پێویستی بە ڕاوێژکردنە لەگەڵ فرۆشگاکە.",
    item_main_board: "مادربۆرد",
    item_screen_frame: "شاشە (چوارچێوە)",
    item_screen_screen_frame: "شاشەی لاوەکی (چوارچێوە)",
    item_touch_screen: "شاشەی تاچ سکرین",
    item_camera: "کامێرا",
    item_fixed_focus_camera: "کامێرای فۆکەسی نەگۆڕ",
    item_auto_focus_camera: "کامێرای فۆکەسی ئۆتۆماتیکی",
    item_screen: "شاشە",
    item_secondary_screen: "شاشەی دووەم",
    item_fingerprint_module: "مۆدیۆلی پەنجەمۆر",
    item_speaker: "بڵندگۆ",
    item_receiver: "وەرگر",
    item_small_board: "بۆردی بچووک",
    item_battery_cover: "کەڤەری پاتری",
    item_battery: "پاتری",
    item_charger: "بارگاویکەر",
    item_usb_cable: "وایەری USB",
    item_lcd: "LCD",
  },
  shopDetails: {
    name1: "هیچ زانیارییەکی تێدا نییە",
    name2: "دابینکاریی خزمەتگوزاری:",
    name3: "بڕەندی خزمەتگوزاری:",
    name4: "تەلەفۆن:",
    name5: "کواڵیتی داواکاری:",
    name6: "پلەبەندیی خزمەتگوزاری",
    name7: "ژینگەی خزمەتگوزاری:",
    name8: "تێڕوانینی خزمەتگوزاری:",
    name9: "لێهاتوویی خزمەتگوزاریی:",
    name10: "کوالیتیی خزمەتگوزاری:",
    name11: "هەڵسەنگاندنی مشتەری",
    name12:"بۆ",
    name13:"داخرا",
  },
  reserSuccess: {
    // name1:
    //   "Carlcare بکەوە",
    name1: "تکایە سکرین شاتێک لە زانیارییەکانی رێزێرفەکەت بگرە و وەک ڕەسیدێک پاشەکەوتی بکە بۆ دەستڕاگەیشتنی خزمەتگوزاریی لەپێشترێتی.",
    name2: "سەرکەوتووانە پێشکەش کرا",
    name3: "١. دێیتاکان بسڕەوە",
    name4: "تکایە لەپێشتردا دێیتا تایبەتییە گرینگەکانی مۆبایلەکەت بگەڕێنەوە",
    name5: "٢. قفڵی هەڵکردن بە تێپەڕوشە ناچالاک بکە",
    name6: "پێش ئەوەی بچییە فرۆشگای فرۆشتن، تکایە:",
    name7: "فرۆشگای خزمەتگوزاری:",
    name8: "کاتی ڕێزێرف کردن:",
    name9: "شی کردنەوەی کێشە:",
    name10: "مۆدێلی ئامێر:",
    name11: "ژمارەی فرمان:",
    name12: "پۆلێنی زانیارییەکان",
  },
  title: {
    name1: "پشتیوانی لەم وڵاتانەی خوارەوە دەکات:",
    name2: "هەڵبژاردنی مۆدێل",
    name3: "ڕێزێرڤ",
    name4: "وەردەکارییەکانی فرۆشگای خزمەتگوزاری",
    name5: "فرۆشگای خامتگوزاری هەڵبژێرە",
  },
  error: {
    name1: "هیچ زانیارییەکی تێدا نییە. تکایە زانیارییەکانی چاککردنەوەت بپشکنە",
    name2: "پێویستیت بە یارمەتیی زیاتر هەیە؟ تکایە پەیوەندیمان پێوە بکە.",
    name3: "ببوورە، لەم هەرێمەی ئێستادا هیچ ناوەندێکی Carlcare نییە.",
    name4: "تکایە سەرەتا ناوەندێکی خزمەتگوزاری هەڵبژێرە",
    name5: "شکستهێنان",
    name6: "تکایە سەرتا مۆدێلی ئامێر هەڵبژێرە",
    name7: "وردەکاری",
    name8: "تکایە پێداویستییەکانت بە وردی شی بکەوە",
    name9: "",
  },
  add1:{
    "name0": "ckb-rIQ",
    "name1": "داواکارییەکەت پشتڕاست کراوەتەوە. چاوەڕوانی هاتنت دەکەین.",
    "name2": "دەستنیشانکردنی شار",
    "name3": "تکایە ژمارەیەکی مۆبایل بنووسە %1$s لە ژمارەکان.",
    "name4": "کاتژمێرەکانی ڕۆژانی هەفتە",
    "name5": "دووشەممە",
    "name6": "سێ شەممە",
    "name7": "چوارشەممە",
    "name8": "پێنجشەممە",
    "name9": "هەینی",
    "name10": "شەممە",
    "name11": "یەک شەممە",
    "name12": "وڵات بنووسە و بگەڕێ"
  },
  add2:{
    "name0": "English",
    "name1": "Repair Method：",
    "name2": "In-store Repairs",
    "name3": "Delivery service",
    "name4": "Fault Type",
    "name5": "Tap to select fault type",
    "name6": "Pick-up Time",
    "name7": "Tap to select pick-up time",
    "name8": "Pick-up Address",
    "name9": "Please input your house number/street/district/province",
    "name10": "Please input your postal code",
    "name11": "Add returning address",
    "name12": "Returning Address",
    "name13": "ئەوانی دیکە",
    "name14": "Please describle your dexice problem in detail!",
    "name15": "Sending Post Code",
    "name16": "Please input your returning number/street/district/province",
    "name17": "Please input your returning code",
    "name18": "Returning Post Code",
    "name19": "Sending Address",
    "name20": "Choose your province",
  },
  coupons: {
    name1:"Coupons",
    name2:"بۆ گۆڕینی ئاراستەکە دایگرە",
    name3:"بۆ هەڵسەنگاندنی داواکارییەکە ئەپلیکەیشنی Carlcare بکەوە",
    name4:"Navigate by Google Maps",
    name5:"Navigate by Yandex Maps",
    name6:"خزمەتگوزاری هەڵبژێرە",
    name7:"پاککردنەوەی بێ بەرامبەر",
    name8:"Software Upgrade",
  },
  cancelorder:{
    "cancelReason0": "زانیاری هەڵە",
    "cancelReason1": "لە کاتی خۆیدا ناگاتێ",
    "cancelReason2": "داواکاری دوبارە/ داواکاری من نییە",
    "cancelReason3": "هەڵە دووبارە نابێتەوە",
    "cancelReason4": "تەنیا بۆ تاقیکردنەوە/ پرسیار/ڕووداو/…",
    "cancelReason5": "نرخی بەرز",
    "cancelReason6": "کەمیی مەتریاڵ",
    "cancelReason7": "خزمەتگوزاری جیاواز نییە",
    "cancelReason8": "ئەم فرۆشگایە زۆر دوورە",
    "cancelReason9": "فرۆشگاکە داخراوە",
    "cancelReason10": "حاڵەتی خزمەتگوزاری هەڵە",
    "cancelReason11": "گۆڕین/چاککردنەوەی پەیوەست بە براندەکانی تر",
    "cancelReason12": "دۆزینەوەی فرۆشگا مومکین نییە",
    "cancelReason13": "ئەوانی دیکە",
    "cancelOrder": "هەڵوەشاندنەوەی فرمان",
    "reason_dialog_title": "تکایە هۆکاری هەوڵوەشانەوەمان پێ بڵێ",
    "Cancel": "هەڵوەشاندنەوە",
    "OK": "باشە",
    "name1": "کۆدی گۆڕین بنووسە",
    "name2": "کۆدی پشتڕاستکردنەوەی چەوت",
    "repair_reservation_detail_canceled": "ئەم داواکارییە هەڵوەشێندراوەتەوە!",
    "purchase_cancel_dialog_content": "ئایا هەڵوەشاندنەوەی داواکارییەکە پشتڕاست دەکەیەوە؟",
    "yes": "بەڵێ",
    "no": "نا"
}
};
